<template>
<div class="to-self">
  <el-row>
    <el-col>
      <div class="account-list-top-text">{{$t('Accounts_receivable')}}</div>
      <mtaccount-list
        :exclude-login="currentAccount"
        ref="tomtlist"
      ></mtaccount-list>
    </el-col>
    <el-col
      :lg="8"
      :sm="8"
      :xs="24"
    >
      <el-form
        class="elform"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item
            class=""
        >
          <div class="nav-title">{{$t('Amount_that_can_be_withdrawn')}}</div>
          <p class="balance">${{fromAccountInfo.availableBalance || 0}}</p>
        </el-form-item>
        <el-form-item
          :label="$t('User.transAmount')"
          prop="amount"
          class="has-prefix-item"
        >
          <el-input
            :placeholder="$t('please_input')"
            :value="form.amount"
            @input="inputHandle"
          >
            <span slot="prefix">$</span>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              :disabled="btnDisabled"
              :loading="submitLoading"
            @click="payHandle"
          >{{$t('Confirm_transfer_out')}}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</div>
</template>

<script>
import mtaccountList from "@/components/public/mtaccountList";
import { mt4Transfer } from '@/api/userCenter.js';
import {amountInputValidate, onlyTwoBitFloat} from "@/utils/validate";
import { mapGetters } from 'vuex'
export default {
  name: "toSelf",
  components: {
    mtaccountList,
  },
  props: {
    currentAccount: {
    },
    accountList:{
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        }else {
          callback();
        }
      }
    };
    return {
      // 表单
      form: {
        toAccount: '',
        amount: '',
      },
      rules: {
        toAccount: [
          // { required: true, message: _this.$t('please_choose'), trigger: 'change' },
        ],
        amount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
      },
      submitLoading: false,

      excludeLogin: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    toAccountList() {
      // 需要排除转账过来的账号
      if(!this.accountList.length){
        return [];
      }else {
        let toList = this.accountList.filter((item) =>{
          return item.login != this.currentAccount;
        });
        return toList;
      }
    },
    fromAccountInfo(){
      if(!this.accountList.length){
        return {
          availableBalance: '',
        }
      }else {
        let currentMtInfo = this.accountList.filter((item) => {
          return item.login == this.currentAccount;
        });
        return currentMtInfo[0];
      }
    },
    btnDisabled(){

    }
  },
  methods: {
    getLabel(item){
      return `MT4 (${item.login}) ${this.$t('balance')}: ${item.balance}`;
    },
    payHandle(item){
      this.$refs.form.validate((valid) => {
        if(valid){
          if(!this.$refs.tomtlist.curLogin){
            this.$message({
              type: 'waring',
              message: this.$t('Please_select_the_payment_account')
            });
          }
          let handlerBalance = this.fromAccountInfo.availableBalance;
          if(!handlerBalance){
            this.$message({
              type: 'waring',
              message: this.$t('The_amount_that_can_be_withdrawn_is_0')
            });
            return;
          }
          this.applyRequest();
        }else {
          console.log('no-pass');
        }
      })
    },
    applyRequest(){
      let parmas = {
        oprCustId : this.userInfo.id,
        transferType : 1,
        oprLogin : this.fromAccountInfo.login,
        targetLogin : this.$refs.tomtlist.curLogin,
        amount : this.form.amount,
        targetEmail : '',
        phoneVerCode : null,
        type: 2,
      }
      this.submitLoading = true;
      mt4Transfer(parmas).then((res) => {
        // 需要减去当前的余额
        this.$refs.tomtlist.getCustMtaccount();
        this.$emit('reduce-balance',this.form.amount);
        this.submitLoading = false;
        this.$message({
          type: 'success',
          message: this.$t('Submitted_the_system_will_arrive_within_24_hours')
        });

      }).catch((res) => {
        this.submitLoading = false;
      })
    },
    inputHandle(val){
      this.form.amount = amountInputValidate(val);
    }
  },
}
</script>

<style lang="scss" scoped>
.to-self {
  .nav-title {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
    margin-top: 20px;
  }
  .balance {
    font-size: 16px;
    font-weight: 600;
    color: #D85E5F;
    line-height: 12px;
  }
  .form-item-nohas-bottom {
    margin-bottom: 0;
  }
  .has-prefix-item {
    /deep/ .el-input__prefix {
      left: 15px;
    }
  }
}
.self-mtlist-select {
  height: 70px;
  .inner-bot {
    padding-left: 34px;
  }
}
.account-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .icon-el {
    width: 24px;
    height: 24px;
  }
  .login {
    padding-left: 10px;
    font-weight: 600;
    font-size: 14px;
  }

}
</style>
